import e from "../hooks/HookBuilder.js";
import { AmenityTypesService as r } from "../services/amenity-types.js";
const t = e.noParamsHook(
  ["amenity-types"],
  r.search,
  {
    errorMessage: "There was an error getting the amenity types"
  }
), s = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useAmenityTypes: t
}, Symbol.toStringTag, { value: "Module" }));
export {
  s as amenityTypes,
  t as useAmenityTypes
};
//# sourceMappingURL=amenity-types-B6TNq1SD.js.map
